import {
  type ColumnDefinition,
  Table,
  type TableProps,
} from "@pharmupp/p3-front-commons"
import { AdherentDefaultFilters } from "../defaultFilters"
import type { ApiAdherentLoyaltyList } from "./types"

export const AdherentsLoyaltyList = ({
  queryConfig,
  exportButtonProps,
  columns,
  extraToolbarElements,
  onRowClick,
}: { columns: ColumnDefinition<ApiAdherentLoyaltyList>[] } & Pick<
  TableProps<ApiAdherentLoyaltyList, ApiAdherentLoyaltyList>,
  "queryConfig" | "exportButtonProps" | "extraToolbarElements"
> & { onRowClick?: (row: ApiAdherentLoyaltyList) => void }) => (
  <Table<ApiAdherentLoyaltyList>
    queryConfig={queryConfig}
    exportButtonProps={exportButtonProps}
    extraToolbarElements={extraToolbarElements}
    FilterSectionElement={<AdherentDefaultFilters />}
    emptyMessage="Pas encore de pharmacie"
    columns={columns}
    onRowClick={onRowClick}
    rowClickCondition={() => !!onRowClick}
  />
)
